import { render, staticRenderFns } from "./chat-with-seller.vue?vue&type=template&id=ac174e06&scoped=true"
import script from "./chat-with-seller.vue?vue&type=script&lang=js"
export * from "./chat-with-seller.vue?vue&type=script&lang=js"
import style0 from "./chat-with-seller.vue?vue&type=style&index=0&id=ac174e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac174e06",
  null
  
)

export default component.exports